/**
 * Seed Cube - XHR leaf transport for user add-to-carts (28/07/2026, r2.1).
 * r2.1: fingerprint bump to force CDN repropagation (content identical to r2).
 * Load in <head> immediately AFTER sc-cart-queue.js.
 *
 * WHY: Shopify's ATC counter is shop_events_listener.js. Its fetch hook lives
 * in the window.fetch wrapper chain, which other scripts sometimes replace
 * non-chained - so on some page loads user adds via fetch are never counted.
 * Its XMLHttpRequest instrumentation is PROTOTYPE-patched and robust.
 * FIX: catch the cart queue's leaf re-entry (init.__SC_LEAF__ on /cart/add.js)
 * and perform the real network call via XHR, returning a synthetic Response.
 * r2: ALWAYS send an explicit Content-Type. Theme form adds post urlencoded
 * string bodies with no header (fetch auto-sets it, XHR defaults to
 * text/plain) - the listener parses the request to extract the product and
 * skips bodies it cannot parse, which silently dropped button adds.
 */
(function () {
  if (window.__SC_ATC_XHR_LEAF__) return;
  window.__SC_ATC_XHR_LEAF__ = true;
  window.__SC_ATC_XHR_LEAF_REV__ = 'r2.1';

  var downstream = window.fetch; // queue wrapper (this loads right after it)

  function headerValue(headers, name) {
    if (!headers) return null;
    try {
      if (typeof headers.get === 'function') return headers.get(name);
      for (var k in headers) {
        if (Object.prototype.hasOwnProperty.call(headers, k) && k.toLowerCase() === name.toLowerCase()) {
          return headers[k];
        }
      }
    } catch (e) {}
    return null;
  }

  function xhrAdd(url, init) {
    return new Promise(function (resolve) {
      try {
        var x = new XMLHttpRequest();
        x.open('POST', typeof url === 'string' ? url : (url && url.url) || '/cart/add.js', true);

        var body = init && init.body != null ? init.body : null;
        var isFormData = typeof FormData !== 'undefined' && body instanceof FormData;
        if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
          body = body.toString();
        }
        var ct = headerValue(init && init.headers, 'Content-Type');
        if (!ct && typeof body === 'string') {
          // r2: default the type so the listener can parse the request
          ct = body.trim().charAt(0) === '{' ? 'application/json' : 'application/x-www-form-urlencoded';
        }
        if (ct && !isFormData) x.setRequestHeader('Content-Type', ct);
        x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        x.setRequestHeader('Accept', 'application/json');
        x.onloadend = function () {
          try {
            resolve(new Response(x.responseText || '', {
              status: x.status || 0,
              headers: { 'Content-Type': x.getResponseHeader('Content-Type') || 'application/json' }
            }));
          } catch (e) {
            resolve(new Response(JSON.stringify({ status: 409, message: 'Cart update failed. Please try again.' }), {
              status: 409, headers: { 'Content-Type': 'application/json' }
            }));
          }
        };
        x.send(body);
      } catch (e) {
        resolve(null);
      }
    });
  }

  window.fetch = function (input, init) {
    try {
      if (init && init.__SC_LEAF__) {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add\.js/.test(u)) {
          return xhrAdd(input, init).then(function (res) {
            return res || downstream.call(window, input, init);
          });
        }
      }
    } catch (e) {}
    return downstream.call(window, input, init);
  };
})();
